<!-- Filters Row -->
<div class="container-fluid p-4 rounded shadow" id="filtersBox">
  <!-- Preload Images -->
  <img src="/assets/images/background/vegetables.png" style="display:none;" alt="Preload Vegetables">
  <img src="/assets/images/background/fruits.jpg" style="display:none;" alt="Preload Fruits">
  <img src="/assets/images/background/meat1.jpg" style="display:none;" alt="Preload Meat">
  <img src="/assets/images/background/dairy.jpg" style="display:none;" alt="Preload Dairy">

  <!-- Existing Content -->
  <div class="d-flex justify-content-center">
    <h3 class="badge lime-green-button1 text-white rounded-pill p-4 text-center">
      Brskaj domače izdelke
    </h3>
  </div>
  <div class="row g-3 d-flex justify-content-center">
    <div class="col-12 col-sm-6 col-md-3 col-lg-2">
      <label for="productTypeFilter" class="form-label fw-bold">Tip izdelka</label>
      <select id="productTypeFilter" class="form-select" [(ngModel)]="productTypeFilter" (change)="applyFilters()">
        <option value="">Vse</option>
        <option value="dairy">Mlečni izdelki</option>
        <option value="vegetable">Zelenjava</option>
        <option value="meat">Mesni izdelki</option>
        <option value="other">Ostalo</option>
      </select>
    </div>
    <div class="col-12 col-sm-6 col-md-3 col-lg-2">
      <label for="searchFilter" class="form-label fw-bold">Išči po ključni besedi</label>
      <input type="text" id="searchFilter" class="form-control" placeholder="Išči izdelke" [(ngModel)]="searchFilter" (keyup.enter)="applyFilters()">
    </div>
    <div class="col-12 col-sm-6 col-md-3 col-lg-2">
      <label for="ratingSortOrder" class="form-label fw-bold">Razvrsti po oceni</label>
      <select id="ratingSortOrder" class="form-select" [(ngModel)]="ratingSortOrder" (change)="applyFilters()">
        <option value="">Brez razvrščanja</option>
        <option value="asc">Naraščajoče</option>
        <option value="desc">Padajoče</option>
      </select>
    </div>
  </div>

  <div class="text-center mt-4">
    <button class="btn btn-secondary fw-bold" (click)="clearFilters()">Počisti izbiro</button>
  </div>
</div>

  
  <div class="text-center m-0">
    <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
  </div>

  <!-- Products Row -->
   <div class="background-container">

     <app-product-list [allProducts]="allProductsShow" [onMarketPage]="isOnMarketPage" [allFarms]="allFarms"></app-product-list>
   </div>

   <div class="text-center m-0">
    <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
  </div>

  <!-- Farms Row -->
  <app-farm-list id="farmList" [allFarms]="allFarms" [isOnMarketPage]="isOnMarketPage"></app-farm-list>

  <div class="text-center m-0">
    <img src="../../assets/images/background/splitLine.png" alt="Split Line" class="split-line-image img-fluid">
  </div>


  <!-- Calendar Row -->
  <div class="container p-4 my-5 position-relative">
    <h3 class="d-flex justify-content-center lime-green-button text-white rounded-pill p-3 fs-5">
      <fa-icon class="me-2 fa-lg" [icon]="faCalendar"></fa-icon>Koledar ponudbe in dogodkov</h3>
    <app-full-calendar [onMarketPage]="isOnMarketPage"></app-full-calendar>
  </div>
